import { atom } from 'recoil';

import { PreviewState } from './../components/AuctionPreview.type';

export const previewState = atom<PreviewState>({
  key: 'auction.create.preview',
  default: {},
});
